import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, InvoiceUpdate, InvoiceUpdateResponse } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateInvoice(): UseMutationResult<
  AxiosResponse<InvoiceUpdateResponse>,
  AxiosError<ErrorMessage>,
  InvoiceUpdate
> {
  const queryClient = useQueryClient();

  const updateInvoice = (payload: InvoiceUpdate): Promise<AxiosResponse<InvoiceUpdateResponse>> => {
    return client.put(`invoices/${payload.invoiceId}/`, payload);
  };

  return useMutation(updateInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries(['invoices']);
      // The package and its chain now change as a side effect of an invoice edit, so the packages
      // list would otherwise keep rendering the old auto-pay and card until something else
      // refetched it. Prefix invalidation, to cover the detail queries of every chain member.
      queryClient.invalidateQueries(['athletePackages']);
    },
  });
}
